import { TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Avatar, Box, Button, CircularProgress } from "@mui/material";
import { ProfileDetailsFormProps } from "../../pages/ProfilePage/types";
import { MobileScreenSaveContainer } from "../../pages/ProfilePage/styles";
import { styles } from "../../pages/ProfilePage/styles";
import { SmallScreenBottomContainer } from "../../pages/ProfilePage/styles";
import { CustomLeftTitle } from "../../pages/ProfilePage/styles";
import { FirstNameContainer } from "../../pages/ProfilePage/styles";
import { SelectField } from "../../pages/ProfileSettings/styles";
import { SocialMediaLinksForm } from "./SocialMediaLinksForm";
import { GenresArray } from "../constants";
import { preferencesStageStyles } from "../InitialSettingsComponents/styles";
import { useStyles } from "../InitialSettingsComponents/styles";
import { APP_COLOR } from "../../theme";
import CheckIcon from "@mui/icons-material/Check";
import { useNavigate } from "react-router-dom";

export const ProfileDetailsForm: React.FC<ProfileDetailsFormProps> = ({
  genreList,
  setGenreList,
  profilePicture,
  setProfilePic,
  setProfilePicBlob,
  setProfilePicFile,
  profilePic,
  links,
  setLinks,
  isSubmitting,
  handleSaveChanges,
  affiliation,
  setAffiliation,
}) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isSmallOrLarger = useMediaQuery(theme.breakpoints.up("sm"));
  const classes = useStyles();

  const handleChangeGenre = (
    _event: React.SyntheticEvent<Element, Event>,
    value: unknown
  ) => {
    const tempGenreArr: string[] = [];
    const values = value as Array<string>;
    const length = values.length;
    for (let i = 0; i < length; i++) {
      const tag_curr = values[i];
      tempGenreArr.push(tag_curr);
    }
    setGenreList(tempGenreArr);
  };

  const sanitizeFileName = (name: string) => {
    return name.normalize("NFKD").replace(/[^a-zA-Z0-9._-]/g, "");
  };

  const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = event.currentTarget;
    if (files && files.length > 0) {
      let file = files[0];

      const sanitizedFileName = sanitizeFileName(file.name);

      file = new File([file], sanitizedFileName, { type: file.type });

      const blob = new Blob([file], { type: file.type });
      const url = URL.createObjectURL(blob);
      setProfilePic(url);
      setProfilePicBlob(blob);
      setProfilePicFile(file);
    }
  };
  const onImageClick = () => {
    if (profilePicture.current) {
      profilePicture.current.click();
    }
  };

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    const items = event.dataTransfer.items;
    const files = event.dataTransfer.files;
    let file: File | null = null;
    if (items && items.length > 0) {
      for (let i = 0; i < items.length; i++) {
        if (items[i].kind === "file") {
          file = items[i].getAsFile();
          break;
        }
      }
    } else if (files && files.length > 0) {
      file = files[0];
    }
    if (file) {
      handleFileChange(file);
    }
  };

  const handleFileChange = (file: File) => {
    if (!file) return;
    const sanitizedFileName = sanitizeFileName(file.name);
    file = new File([file], sanitizedFileName, { type: file.type });
    const blob = new Blob([file], { type: file.type });
    const url = URL.createObjectURL(blob);
    setProfilePic(url);
    setProfilePicBlob(blob);
    setProfilePicFile(file);
  };

  return (
    <>
      <FirstNameContainer>
        <CustomLeftTitle>Genres</CustomLeftTitle>
        <Box
          sx={{
            ...preferencesStageStyles.textFieldContainer,
            ...{ width: isSmallOrLarger ? "40%" : "100%" },
          }}
        >
          <SelectField
            multiple
            value={genreList}
            fullWidth
            id="checkboxes-tags-demo"
            options={GenresArray}
            disableCloseOnSelect
            onChange={(e, v) => handleChangeGenre(e, v)}
            renderOption={(props, option, { selected }) => (
              <li
                {...props}
                style={preferencesStageStyles.list}
                className={classes.customOption}
              >
                {option as string}
                {selected && <CheckIcon style={{ color: APP_COLOR }} />}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                InputLabelProps={{ shrink: false }}
                classes={{ root: classes.customTextField }}
              />
            )}
          />
        </Box>
      </FirstNameContainer>
      <FirstNameContainer
        onClick={onImageClick}
        onDrop={(e) => handleDrop(e)}
        onDragOver={(e) => e.preventDefault()}
      >
        <Box sx={{ minWidth: "40%" }}>
          <Typography sx={{ minWidth: "40%" }}>Your Photo</Typography>
          <Typography>This will be displayed on your profile.</Typography>
        </Box>
        <Box
          sx={{
            width: isSmallOrLarger ? "40%" : "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <input
            type="file"
            id={"image"}
            name={"profilePic"}
            className="input__file"
            ref={profilePicture}
            accept="image/*"
            multiple={false}
            style={{ display: "none" }}
            onChange={onInputChange}
          />
          <Avatar
            sx={{ width: "70px", height: "70px" }}
            alt="ro Sharp"
            src={profilePic ?? ""}
          />
          <Box sx={{ display: "flex", gap: "15px" }}>
            <Button sx={styles.update}>Update</Button>

            <Button
              onClick={(e) => {
                e.stopPropagation();
                setProfilePic("");
              }}
              sx={{ ...styles.skipButton, ...{ border: "none" } }}
            >
              Delete
            </Button>
          </Box>
        </Box>
      </FirstNameContainer>
      <SocialMediaLinksForm
        links={links}
        setLinks={setLinks}
        affiliation={affiliation}
        setAffiliation={setAffiliation}
      />
      <MobileScreenSaveContainer>
        <FirstNameContainer sx={{ borderBottom: "none" }}>
          <CustomLeftTitle></CustomLeftTitle>
          <SmallScreenBottomContainer>
            <Button onClick={handleSaveChanges} sx={styles.button}>
              {isSubmitting ? (
                <CircularProgress size={16} sx={{ color: "black" }} />
              ) : (
                "Save"
              )}
            </Button>
            <Button onClick={() => navigate(-1)} sx={styles.skipButton}>
              Cancel
            </Button>
          </SmallScreenBottomContainer>
        </FirstNameContainer>
      </MobileScreenSaveContainer>
    </>
  );
};
